import { css } from "emotion";
import { vw } from "../cssUtil";
export const containerCommon = {
    position: "fixed",
    zIndex: 9,
    top: 0,
    left: "50%",
    width: "100%",
    maxWidth: "768px",
    height: "100%",
    transform: "translate3d(-50%, 0, 0)"
};
export const inputBoxCommon = {
    position: "relative",
    border: `1px solid #ccc`,
    // backgroundImage: `linear-gradient(45deg, #6c757d12, transparent)`,
    borderRadius: vw(23),
    height: vw(46),
    boxSizing: "border-box",
    overflow: "hidden",
    input: {
        width: "100%",
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        height: "100%",
        fontSize: vw(16),
        padding: `0 ${vw(15)}`,
        color: "#000",
        fontFamily: "PingFang SC,STHeiTi,Hiragino Sans GB,Hiragino Sans GB W3",
        "&:focus": {
            backgroundColor: "#287ef912"
        },
    },
    "@media (min-width: 769px)": {
        borderRadius: "23px",
        height: "46px",
        input: {
            fontSize: "16px",
            padding: `0 15px`
        }
    }
};
export const btnCommon = {
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "> div": {
        textAlign: "center",
        lineHeight: vw(44),
        borderRadius: vw(22),
        fontSize: vw(16),
        color: "#fff",
        flex: 1,
        "&:active": {
            opacity: 0.6
        }
    },
    ".confirm": {
        backgroundColor: "#287ef9"
    },
    ".cancel": {
        backgroundColor: "#b1b1b1",
        marginRight: vw(15)
    },
    "@media (min-width: 769px)": {
        margin: `15px 15px 0`,
        "> div": {
            lineHeight: "44px",
            borderRadius: "22px",
            fontSize: "16px"
        },
        ".cancel": {
            marginRight: "15px"
        }
    }
};
export const containerStyle = css(containerCommon);
